import label from "@/lang/StaticLabels.js";
import { BOOTH_SUBSYSTEM_ID } from "@/config/subSystems.js";

// PSTORE Navbar  - فروش فروشگاهی -----------------------------------------------

let navItems = [
  {
    title: label.modules.pstore,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PSTOREDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
  },
  {
    to: "PSTORESaleFactorAdd",
    label: label.menu.storeSaleFactor,
    metaLabel: label.page.storeSaleFactor,
    icon: "mdi-cash-register",
    active: false,
    subItems: false,
  },
  {
    to: "PSTORECashClosingAdd",
    label: label.menu.storeCashClosing,
    metaLabel: label.page.storeCashClosing,
    icon: "mdi-cash-lock",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.caption.storeDefinitionsAndManagement,
    icon: "mdi-cog-outline",
    active: false,
    subItems: [
      {
        to: "PSTOREStoreList",
        label: label.menu.storeStores,
        metaLabel: label.page.storeStores,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSTOREBoothList",
        label: label.menu.storeBooths,
        metaLabel: label.page.storeBooths,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
        subSystemId: BOOTH_SUBSYSTEM_ID,
      },
      // {
      // to: "PSTOREUsersAndShifts",
      // label: label.menu.storeUsersAndShifts,
      // metaLabel: label.page.storeUsersAndShifts,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTORECashDesksAndTerminals",
      // label: label.menu.storeCashDesksAndTerminals,
      // metaLabel: label.page.storeCashDesksAndTerminals,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      {
        to: "PSTOREPosTerminalTypes",
        label: label.menu.storePosTerminalTypes,
        metaLabel: label.page.storePosTerminalTypes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.storeBenefitCard,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSTOREBenefitCards",
            label: label.menu.storeBenefitCards,
            metaLabel: label.page.storeBenefitCards,
            icon: "mdi-circle-medium",
          },
          {
            to: "PSTOREBenefitCardTransactions",
            label: label.menu.storeBenefitCardTransactions,
            metaLabel: label.page.storeBenefitCardTransactions,
            icon: "mdi-circle-medium",
          },
        ],
      },
      {
        to: "PSTORESalesAgents",
        label: label.menu.storeSalesAgents,
        metaLabel: label.page.storeSalesAgents,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // {
      // to: "PSTORECommissionPolicies",
      // label: label.menu.storeCommissionPolicies,
      // metaLabel: label.page.storeCommissionPolicies,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTOREPricesAndDiscounts",
      // label: label.menu.storePricesAndDiscounts,
      // metaLabel: label.page.storePricesAndDiscounts,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTORESalesReports",
      // label: label.menu.storeSalesReports,
      // metaLabel: label.page.storeSalesReports,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      {
        to: null,
        label: label.menu.storeSettingsAndAccess,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSTOREShopSetting",
            label: label.menu.storeShopSetting,
            metaLabel: label.page.storeShopSetting,
            icon: "mdi-circle-medium",
          },
          {
            to: "PSTOREBoothSetting",
            label: label.menu.storeBoothSetting,
            metaLabel: label.page.storeBoothSetting,
            icon: "mdi-circle-medium",
            subSystemId: BOOTH_SUBSYSTEM_ID,
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.caption.storeOperations,
    icon: "mdi-storefront-outline",
    active: false,
    subItems: [
      {
        to: "PSTOREPreOrderList",
        label: label.menu.storePreOrder,
        metaLabel: label.page.storePreOrder,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
        // فقط وقتی زیرسیستم غرفه برای شرکت فعال باشد
        subSystemId: BOOTH_SUBSYSTEM_ID,
      },
      {
        to: "PSTORECashClosingCartable",
        label: label.menu.storeCashClosingCartable,
        metaLabel: label.page.storeCashClosingCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSTORECashClosingManagementCartable",
        label: label.menu.storeCashClosingManagementCartable,
        metaLabel: label.page.storeCashClosingManagementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // {
      // to: "PSTOREQuickSale",
      // label: label.menu.storeQuickSale,
      // metaLabel: label.page.storeQuickSale,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTORESaleReturn",
      // label: label.menu.storeSaleReturn,
      // metaLabel: label.page.storeSaleReturn,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTORECashDesksAndBooths",
      // label: label.menu.storeCashDesksAndBooths,
      // metaLabel: label.page.storeCashDesksAndBooths,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
      // {
      // to: "PSTOREDeliveryAndShipping",
      // label: label.menu.storeDeliveryAndShipping,
      // metaLabel: label.page.storeDeliveryAndShipping,
      // icon: "mdi-subdirectory-arrow-left",
      // active: false,
      // subItems: [],
      // },
    ],
  },
  // {
  // to: null,
  // label: label.caption.storeCustomers,
  // icon: "mdi-account-group-outline",
  // active: false,
  // subItems: [
  // {
  // to: "PSTORECustomerClub",
  // label: label.menu.storeCustomerClub,
  // metaLabel: label.page.storeCustomerClub,
  // icon: "mdi-subdirectory-arrow-left",
  // active: false,
  // subItems: [],
  // },
  // {
  // to: "PSTOREAfterSalesService",
  // label: label.menu.storeAfterSalesService,
  // metaLabel: label.page.storeAfterSalesService,
  // icon: "mdi-subdirectory-arrow-left",
  // active: false,
  // subItems: [],
  // },
  // ],
  // },
];

export default navItems;
